
require('../layout');
require("slick-carousel");
require("@fancyapps/fancybox");



$("#hero").find('.slide-project-hero').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    prevArrow: $("#hero").find(".arrows .prev"),
    nextArrow: $("#hero").find(".arrows .next"),
})

$("#hero").find('.slide').slick({
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
})
$("#regions-slide").find('.slide').slick({
    centerMode: true,
    centerPadding: 0,
    arrows: false,
    dots: false,
    infinite: false,
    speed: 300,
    autoplay: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    variableWidth: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                centerMode: true,
                centerPadding: 0,
                slidesToShow: 4,
                vertical: false,
                verticalSwiping: false,
                variableWidth: true,
            }
        },
        {
            breakpoint: 575,
            settings: {
                centerMode: true,
                centerPadding: 0,
                slidesToShow: 2,
                vertical: false,
                verticalSwiping: false,
                variableWidth: true,
            }
        }
    ]
})



$("#project-slide").on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(".slick-count .big").text("0" + i);
    $(".slick-count .small").text("/0" + slick.slideCount);
}).find('.slide-projects').slick({
    arrows: true,
    dots: false,
    infinite: false,
    speed: 300,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: $("#project-slide").find(".arrows .prev"),
    nextArrow: $("#project-slide").find(".arrows .next"),
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
})


$("#regions-slide .slide").find(".region-name").on('click', function (event) {
    event.preventDefault();
    $("#project-slide").find('.slide-projects').slick("slickUnfilter");
    var filter = $(this).data('filter');
    $("#regions-slide .slide").find('.region-name').removeClass('active');
    $(this).addClass('active');

    if (filter == 'all') {
        $("#project-slide").find('.slide-projects').slick("slickUnfilter");
    } else {
        $("#project-slide").find('.slide-projects').slick("slickFilter", function () {
            return $(this).find('.item').data("region") == filter;
        })
    }
})



$("#last-projects").find('.slide-last-projects').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(".last-proyect-count .big").text("0" + i);
    $(".last-proyect-count .small").text("/0" + slick.slideCount);
}).slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    fade: false,
    prevArrow: $("#last-projects").find(".arrows .prev"),
    nextArrow: $("#last-projects").find(".arrows .next"),
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                fade: true,
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                fade: true,
            }
        }
    ]
})

require("../componentes/proyecto/modal_promotion");
